import styled from "styled-components";

const TooltipBlock = styled.span`
  width: 18px;
  height: 18px;
  box-sizing: border-box;
  position: relative;
  margin-left: 7px;
`;

TooltipBlock.Icon = styled.span`
  background: #432f65;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  opacity: ${(props) => props.opacity || 0.7};
  display: inline-block;
  text-align: center;
  top: 2px;
  position: relative;
  img {
    margin: 0 auto;
    margin-bottom: 2px;
  }
`;

TooltipBlock.Message = styled.div`
  width: 100%;
  background: #ffffff;
  border: 0.5px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  padding: 13px 38px 13px 10px;
  box-sizing: border-box;
  position: absolute;
  bottom: 30px;
  left: ${(props) => props.left || 0}px;
  // transform: translateX(${(props) => props.translateX || 0}px);
  &::after {
    content: "";
    position: absolute;
    left: ${(props) => -props.left - 3 || 0}px;
    bottom: -20px;
    border: 10px solid transparent;
    border-top: 10px solid #ffffff;
  }
`;

TooltipBlock.Close = styled.div`
  position: absolute;
  top: 5px;
  right: 10px;
  img {
    width: 100%;
  }
`;

export { TooltipBlock };
